import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { PaymentProvider, usePaymentOptions } from '@/shared/checkout/usePaymentOptions';
import { computed } from 'vue';
import type { Component } from 'vue';
import CheckoutPaymentFinalizeDisabled from '@/b2b/checkout/ui/payment/CheckoutPaymentFinalizeDisabled.vue';
import CheckoutPaymentFinalizeBankTransfer from '@/b2b/checkout/ui/payment/CheckoutPaymentFinalizeBankTransfer.vue';
import CheckoutPaymentFinalizeAltaPay from '@/b2b/checkout/ui/payment/CheckoutPaymentFinalizeAltaPay.vue';
import CheckoutPaymentFinalizeHasSufficientPayments
    from '@/b2b/checkout/ui/payment/CheckoutPaymentFinalizeHasSufficientPayments.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutPaymentFinalize',
  setup(__props) {

const { selectedProvider } = usePaymentOptions();

const componentBySelectedProvider = computed<Component>(() => {
    switch (selectedProvider.value) {
    case PaymentProvider.AltaPay:
        return CheckoutPaymentFinalizeAltaPay;
    case PaymentProvider.BankTransfer:
        return CheckoutPaymentFinalizeBankTransfer;
    case PaymentProvider.HasSufficientPayments:
        return CheckoutPaymentFinalizeHasSufficientPayments;
    default:
        return CheckoutPaymentFinalizeDisabled;
    }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(componentBySelectedProvider)), { class: "block mx-auto" }))
}
}

})